export default {
  SET_AUTHENTICATED: 'setAuthenticated',
  SET_TOKEN: 'setToken',
  SET_USER_DATA: 'setUserData',
  SET_USER_ROLES: 'setUserRoles',
  SET_LAST_PATH: 'setLastPath'
}
